import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { map }        from 'rxjs/operators';
import { ClassSchedule } from '../../models/api/class-schedule.model';
import { ClassesCourse } from '../../models/api/classes-course.model';

import { AppConfigurationService } from '../configuration/app-configuration.service';

@Injectable({
    providedIn: 'root'
})
export class ClassService {

    private apiURL : string;

    private classesScheduleActiveData  = new Subject<ClassSchedule[]>();
    public  classesScheduleActiveData$ = this.classesScheduleActiveData.asObservable();

    private classesCoursesData  = new Subject<ClassesCourse[]>();
    public  classesCoursesData$ = this.classesCoursesData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) { 

        this.apiURL = this.appConfigurationService.baseApi + '/class';

    }

    getClassesScheduleByEditionId(editionId: number): any {

        const url = this.apiURL + '/classSchedule/' + editionId;
        return this.http.get<ClassSchedule[]>(url).pipe(
            map((data) => {
                this.classesScheduleActiveData.next(data);
            })
        );
        
    }
    
    getClassesCoursesByEditionId(editionId: number): any {

        const url = this.apiURL + '/edition/' + editionId;
        return this.http.get<ClassesCourse[]>(url).pipe(
            map((data) => {
                this.classesCoursesData.next(data);
            })
        );
        
    }

}
